<div class="clr-row nxm h-100" #datagridwrapper>
  <div
    class="h-100 padding-10-b padding-10-lr"
    [style.width.%]="
      !showdetailview() || hidedetailview() ? '100'
      : split50() ? '50'
      : '66.66'
    ">
    <div id="toolbar" class="clr-row nxm clr-justify-content-between clr-align-items-end">
      <div>
        <button
          class="btn btn-outline btn-sm"
          style="min-width: 42px"
          (click)="filterStore.deleteAllFilters()"
          [disabled]="filterStore.filteredRows().length == table()?.rows.length">
          <cds-icon shape="filter-off" size="16" [title]="'Alle Filter zurücksetzen' | mrTranslate" />
        </button>
        <button class="btn btn-outline btn-sm" style="min-width: 42px" (click)="exportCSV()">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="excel" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
              {{ 'Liste nach Excel exportieren' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>
        <button
          class="btn btn-outline btn-sm"
          style="min-width: 42px"
          (click)="isMultiAuftragModalOpen.set(true)"
          [disabled]="
            authService.token.rights.status <= 2 ||
            activeTab() == 'Done' ||
            activeTab() == 'Auftrag' ||
            !selected().length ||
            !allowAuftr
          ">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="pinboard" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
              {{ 'Auftrag erstellen' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>
        <button
          class="btn btn-outline btn-sm"
          style="min-width: 42px"
          (click)="isMultiRueckModalOpen.set(true)"
          [disabled]="authService.token.rights.status <= 2 || activeTab() == 'Done' || !selected().length">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="redo" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
              {{ 'Rückmeldung anlegen' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>
      </div>
      <clr-toggle-container clrInline class="nm margin-3-t" style="display: inline-flex">
        <clr-toggle-wrapper>
          <input
            clrToggle
            type="checkbox"
            [(ngModel)]="allInspections"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="reloadMangel()" />
          <label>{{ 'alle Inspektionen' | mrTranslate }}</label>
        </clr-toggle-wrapper>
      </clr-toggle-container>
    </div>

    <div id="maengeltabs">
      @if (loading()) {
        <div class="flexCenterWrapper"><clr-spinner /></div>
      } @else {
        <clr-tabs>
          <!-- 1. TAB: OFFENE -->
          <clr-tab>
            <button clrTabLink [title]="'Offene' | mrTranslate" [attr.data-test-id]="'tab-maengel-open'">
              {{ 'Offene' | mrTranslate | titlecase }}
            </button>
            <ng-template [clrIfActive]="activeTab() == 'Open'" (clrIfActiveChange)="$event && activeTab.set('Open')">
              <clr-tab-content><ng-container *ngTemplateOutlet="tab_content" /></clr-tab-content>
            </ng-template>
          </clr-tab>

          <!-- 2. TAB: BEAUFTRAGTE -->
          <clr-tab>
            <button clrTabLink [title]="'Beauftragte' | mrTranslate" [attr.data-test-id]="'tab-maengel-auftrag'">
              {{ 'Beauftragte' | mrTranslate | titlecase }}
            </button>
            <ng-template
              [clrIfActive]="activeTab() == 'Auftrag'"
              (clrIfActiveChange)="$event && activeTab.set('Auftrag')">
              <clr-tab-content><ng-container *ngTemplateOutlet="tab_content" /></clr-tab-content>
            </ng-template>
          </clr-tab>

          <!-- 3. TAB: ERLEDIGTE -->
          <clr-tab>
            <button clrTabLink [title]="'Erledigte' | mrTranslate" [attr.data-test-id]="'tab-maengel-done'">
              {{ 'Erledigte' | mrTranslate | titlecase }}
            </button>
            <ng-template [clrIfActive]="activeTab() == 'Done'" (clrIfActiveChange)="$event && activeTab.set('Done')">
              <clr-tab-content><ng-container *ngTemplateOutlet="tab_content" /></clr-tab-content>
            </ng-template>
          </clr-tab>

          <!-- 4. TAB: ALLE -->
          <clr-tab>
            <button clrTabLink [title]="'Alle' | mrTranslate" [attr.data-test-id]="'tab-maengel-all'">
              {{ 'Alle' | mrTranslate | titlecase }}
            </button>
            <ng-template [clrIfActive]="activeTab() == 'All'" (clrIfActiveChange)="$event && activeTab.set('All')">
              <clr-tab-content><ng-container *ngTemplateOutlet="tab_content" /></clr-tab-content>
            </ng-template>
          </clr-tab>

          <!-- 5. TAB: Wartung-->
          @if (tables().Wartung.rows.length) {
            <clr-tab>
              <button clrTabLink [title]="'Wartung' | mrTranslate" [attr.data-test-id]="'tab-maengel-wartung'">
                {{ 'Wartung' | mrTranslate | titlecase }}
              </button>
              <ng-template
                [clrIfActive]="activeTab() == 'Wartung'"
                (clrIfActiveChange)="$event && activeTab.set('Wartung')">
                <clr-tab-content><ng-container *ngTemplateOutlet="tab_content" /></clr-tab-content>
              </ng-template>
            </clr-tab>
          }

          <!-- 6. TAB: Störung-->
          @if (tables().Stoerung.rows.length) {
            <clr-tab>
              <button clrTabLink [title]="'Störung' | mrTranslate" [attr.data-test-id]="'tab-maengel-stoerung'">
                {{ 'Störung' | mrTranslate | titlecase }}
              </button>
              <ng-template
                [clrIfActive]="activeTab() == 'Stoerung'"
                (clrIfActiveChange)="$event && activeTab.set('Stoerung')">
                <clr-tab-content><ng-container *ngTemplateOutlet="tab_content" /></clr-tab-content>
              </ng-template>
            </clr-tab>
          }
        </clr-tabs>

        <ng-template #tab_content>
          @if (table()?.columns.length) {
            <clr-datagrid
              class="datagrid-compact h-100"
              [clrDgSelectionType]="'multi'"
              [clrDgSelected]="selected()"
              (clrDgSelectedChange)="UpdateSelected($event)"
              [clrDgItemsIdentityFn]="row => row?.omazsid"
              [attr.data-test-id]="'datagrid-' + activeTab() + ''">
              <clr-dg-column style="min-width: 50px; width: 60px">{{ 'Medien' | mrTranslate }}</clr-dg-column>
              @for (column of table().columns; track column.id) {
                <clr-dg-column
                  #columns
                  [clrDgField]="column.id"
                  [attr.id]="'datagrid-' + activeTab() + '-col-' + (column.id | get: normalizedId)"
                  [attr.data-test-id]="'datagrid-' + activeTab() + '-col-' + column.id">
                  <clr-dg-filter [attr.data-test-id]="'datagrid-' + activeTab() + '-col-' + column.id">
                    <app-column-filter
                      [column]="column"
                      [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                      [objektTypIconValue]="filterStore.iconMap()"
                      (changes)="filterStore.onChange($event)" />
                  </clr-dg-filter>
                  <ng-template
                    [clrDgHideableColumn]="hideableState(column.id)"
                    (clrDgHiddenChange)="columnHiddenChange()">
                    {{ column.id | titlecase | mrUnitText }}
                  </ng-template>
                </clr-dg-column>
              }
              <ng-template
                clrVirtualScroll
                let-row
                let-i="index"
                [clrVirtualRowsOf]="filterStore.filteredRows()"
                [clrVirtualRowsMaxBufferPx]="3000"
                [clrVirtualRowsTrackBy]="(_, row) => row?.omazsid">
                <clr-dg-row [clrDgItem]="row" [attr.data-test-id]="'datagrid-' + activeTab() + '-row'">
                  <clr-dg-action-overflow>
                    <button class="action-item" (click)="openObject(row.ostammid, row.rechte)">
                      {{ 'Öffnen' | mrTranslate }}
                    </button>
                    <button
                      class="action-item"
                      (click)="openBemerkung(row.bemerkung, row.omazsid)"
                      [disabled]="authService.token.rights.status <= 2">
                      {{ 'Bemerkung eintragen' | mrTranslate }}
                    </button>
                    <button
                      class="action-item"
                      (click)="openSonderinspektion(row)"
                      [disabled]="authService.token.rights.status <= 2">
                      {{ 'Sonderinspektion anlegen' | mrTranslate }}
                    </button>
                  </clr-dg-action-overflow>

                  <clr-dg-cell style="min-width: 50px; width: 60px">
                    <ng-container *ngTemplateOutlet="mediaCell; context: { $implicit: row }"></ng-container>
                  </clr-dg-cell>
                  @for (cell of table().columns; track cell.id) {
                    <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                  }
                </clr-dg-row>
              </ng-template>
              <clr-dg-footer>
                <div class="footerbox">
                  <div class="footerbox-actions">
                    <button
                      class="minibutton"
                      [title]="'Spaltenfilter löschen' | mrTranslate"
                      (click)="removeColFilter()">
                      <cds-icon shape="filter-off" />
                    </button>
                    <app-column-manager-popup
                      [columns]="table().columns"
                      (orderChange)="onColumnOrderChange($event)"></app-column-manager-popup>
                  </div>
                  <div class="dbNameTable">{{ formatDBName }}</div>
                  <div>{{ filterStore.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</div>
                </div>
              </clr-dg-footer>
            </clr-datagrid>
          }
        </ng-template>

        <ng-template #mediaCell let-row>
          <a
            href="javascript:void(0);"
            (click)="mangelMedia.set(media.parseMediaPath(row.mangelfoto, row.rueckbilder))"
            [class.deactivate]="!row.mangelfoto && !row.rueckbilder">
            <cds-icon [shape]="!row.mangelfoto && !row.rueckbilder ? 'blank' : 'image-gallery'" size="20" />
          </a>
        </ng-template>
      }
    </div>
  </div>

  @if (showdetailview()) {
    <div
      #dvwrapper
      id="wrapperdetailview"
      [class.sidenavenlarged]="sidenavenlarged()"
      [class.split50]="split50()"
      [class.hidedetailview]="hidedetailview()">
      <app-detailview
        [ostammid]="ostammid()"
        [rechte]="rechte()"
        [progressbarenlarged]="progressbarenlarged()"
        [expanded]="sidenavenlarged()"
        [hidden]="hidedetailview()"
        [split50]="split50()"
        (enlarge)="enlargeSidenav($event)"
        (enlargePB)="enlargeProgressbar(true)"
        (progressData)="showProgressData($event)"
        (indexScrub)="handleScrub($event)"
        (reload)="reloadMangel($event)"
        #detailView />
    </div>
  }

  <clr-modal [clrModalOpen]="showbemerkung()" (clrModalOpenChange)="showbemerkung.set($event)">
    <h3 class="modal-title">{{ 'Bemerkung eintragen' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm>
        <clr-textarea-container>
          <textarea
            id="aa"
            class="clr-col-md-12"
            [placeholder]="'Tragen Sie hier die Bemerkung für den Mangel ein' | mrTranslate"
            clrTextarea
            [(ngModel)]="mangelbemerkung"
            name="bemerkung"
            required
            style="width: 100%; height: 150px"></textarea>
        </clr-textarea-container>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="saveMangelBemerkung()">
        {{ 'Bemerkung speichern' | mrTranslate }}
      </button>
    </div>
  </clr-modal>

  @if (isMultiAuftragModalOpen()) {
    <app-multi-auftrag-modal (onClose)="closeMultiAuftragModal($event)" [maengel]="selected()" />
  }
  @if (isMultiRueckModalOpen()) {
    <clr-modal [clrModalOpen]="isMultiRueckModalOpen()" (clrModalOpenChange)="isMultiRueckModalOpen.set($event)" [clrModalSize]="'full-screen'" id="multirueckmeldung">
      <h3 class="modal-title">{{ 'Rückmeldung' | mrTranslate }}</h3>
      <div class="modal-body"  style="height: 100%;">
        <app-multirueckmeldungdialog
              [auftrag]="undefined"
              [maengel]="selectedTable()">
        </app-multirueckmeldungdialog>
      </div>
    </clr-modal>
  }
  <app-sonderinspektionmodal />
</div>

@if (showprogressbar()) {
  <div id="progresstrigger" [class.bottom]="!progressbarenlarged()">
    <div class="wrap" (click)="enlargeProgressbar()">
      <cds-icon
        shape="angle"
        [direction]="progressbarenlarged() ? 'down' : 'up'"
        class="expandProgressbarButton cursor-pointer" />
    </div>
  </div>
  @if (progressbarenlarged()) {
    <footer id="wrapperprogressbars" class="clr-row nxm clr-align-items-center">
      <app-progressbar
        [dataIn]="progressbars()"
        [indexScrub]="indexScrub()"
        (enlargeProgressbar)="enlargeProgressbar(true)"
        style="display: inline-block; width: calc(100% - 35px)" />
    </footer>
  }
}
@if (mangelMedia()) {
  <app-mediaviewmodal
    (onClose)="mangelMedia.set(undefined)"
    [srcs]="mangelMedia()"
    [getMediaFromServerAll]="media.getApiFunctionMedia"
    [getBigFileFnc]="media.getApiFunctionMediaBig" />
}
